<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <rect x="2.5" y="4.5" width="12" height="8" rx="2.5" stroke="#E5E5E5" stroke-width="1.4"/>
  <ellipse cx="4.5" cy="8.5" rx="1.2" ry="3" fill="#E5E5E5"/>
  <line x1="7.5" y1="5.5" x2="7.5" y2="11.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
  <line x1="10" y1="5.5" x2="10" y2="11.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
  <line x1="12.5" y1="5.5" x2="12.5" y2="11.5" stroke="#E5E5E5" stroke-width="1.1" stroke-linecap="round"/>
</svg>
